import ModalEmail from '@/components/modal/ModalEmail.vue';
import { useModal } from '@orion.ui/orion';

class EmailService {

	static sendEmailAsync (email: Armado.Email, documentType: DOCUMENT_TYPE, documentIds: number[], props?: Record<string, any>, options?:Orion.Modal.Options) {
		return new Promise((resolve) => {
			useModal({
				...options,
				title: `Envoyer un email`,
				Nested: ModalEmail,
				NestedProps: {
					...props,
					email,
					documentType,
					documentIds,
					resolve,
				},
			});
		});
	}
}


export default function useEmailService () {
	return EmailService;
}
